import { ReactElement } from "react";
import { LogoIcon } from "@justworkshr/milo-icons";

import classNames from "util/classNames";

import styles from "./header.module.css";

const Header = ({ title = "" }: { title?: string }): ReactElement => (
  <header
    aria-label="app-header"
    className={classNames([
      styles.container,
      { [styles.noTitle]: !title.length },
    ])}
  >
    <LogoIcon
      brand="justworks"
      color="black"
      title="Justworks"
      width={110}
      className={styles.jwLogo}
    />

    <div className={styles.label}>{title}</div>
  </header>
);

export default Header;
